import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaReactions from './media-reactions-model'
import {
  CreateMediaReactionsAsync,
  DeleteMediaReactionsAsync,
  LoadMediaReactionssAsync,
} from './mediaReactions-thunk'
const initialState: mediaReactionsSliceState = {
  mediaReactions: [],
  selected_mediaReactions: '',
  is_loading_mediaReactions: false,
  is_creating_mediaReactions: false,
  is_deleting_mediaReactions: false,
}
export interface mediaReactionsSliceState {
  mediaReactions: MediaReactions[]
  selected_mediaReactions?: string
  is_loading_mediaReactions: boolean
  is_creating_mediaReactions: boolean
  is_deleting_mediaReactions: boolean
}
export const mediaReactionsSlice = createSlice({
  name: 'mediaReactions',
  initialState,
  reducers: {
    setSelectedmediaReactions: (state, action) => {
      state.selected_mediaReactions = action.payload
    },
    clearStatemediaReactions: (state) => {
      state.mediaReactions = []
      state.is_loading_mediaReactions = false
      state.is_creating_mediaReactions = false
      state.is_deleting_mediaReactions = false
    },
    mergemediaReactions: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaReactions = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaReactions = merge(state.mediaReactions, payload) as any
        }
      }
    },

    add_mediaReactions: (state, action) => {
      if (action.payload) {
        state.mediaReactions = [...state.mediaReactions, action.payload]
      }
    },
    set_mediaReactions: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaReactions = state.mediaReactions.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaReactionssAsync.pending, (state) => {
      state.is_loading_mediaReactions = true
    })
    builder.addCase(LoadMediaReactionssAsync.fulfilled, (state, action) => {
      state.is_loading_mediaReactions = false
      if (action.payload) {
        state.mediaReactions = action.payload
      }
    })
    builder.addCase(LoadMediaReactionssAsync.rejected, (state) => {
      state.is_loading_mediaReactions = false
    })
    builder.addCase(CreateMediaReactionsAsync.pending, (state) => {
      state.is_creating_mediaReactions = true
    })
    builder.addCase(CreateMediaReactionsAsync.fulfilled, (state) => {
      state.is_creating_mediaReactions = false
    })
    builder.addCase(CreateMediaReactionsAsync.rejected, (state) => {
      state.is_creating_mediaReactions = false
    })
    builder.addCase(DeleteMediaReactionsAsync.pending, (state) => {
      state.is_deleting_mediaReactions = true
    })
    builder.addCase(DeleteMediaReactionsAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaReactions = false
      if (state.mediaReactions) {
        state.mediaReactions = state.mediaReactions.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaReactionsAsync.rejected, (state) => {
      state.is_deleting_mediaReactions = false
    })
  },
})

export const {
  clearStatemediaReactions,
  setSelectedmediaReactions,
  set_mediaReactions,
  mergemediaReactions,
  add_mediaReactions,
} = mediaReactionsSlice.actions

export const get_mediaReactions =
  (id?: string) =>
  (state: {
    mediaReactions: {
      mediaReactions: MediaReactions[]
    }
  }): MediaReactions | null => {
    let temp = state?.mediaReactions?.mediaReactions?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaReactions?.mediaReactions[0] || null
  }
export const get_selected_mediaReactions = (state: {
  mediaReactions: mediaReactionsSliceState
}): MediaReactions | null => {
  let id = state?.mediaReactions?.selected_mediaReactions
  let temp = state?.mediaReactions?.mediaReactions?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaReactions = (state: {
  mediaReactions: {
    mediaReactions: MediaReactions[]
  }
}): MediaReactions[] => {
  let temp = state?.mediaReactions?.mediaReactions
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaReactions_busy = (state: {
  mediaReactions: mediaReactionsSliceState
}) => {
  return (
    state?.mediaReactions.is_deleting_mediaReactions ||
    state?.mediaReactions.is_loading_mediaReactions ||
    state?.mediaReactions.is_creating_mediaReactions
  )
}
export const is_deleting_mediaReactions_busy = (state: {
  mediaReactions: mediaReactionsSliceState
}) => {
  return state?.mediaReactions.is_deleting_mediaReactions
}
export const is_loading_mediaReactions_busy = (state: {
  mediaReactions: mediaReactionsSliceState
}) => {
  return state?.mediaReactions.is_loading_mediaReactions
}
export const is_creating_mediaReactions_busy = (state: {
  mediaReactions: mediaReactionsSliceState
}) => {
  return state?.mediaReactions.is_creating_mediaReactions
}

export default mediaReactionsSlice.reducer
